module.exports = __webpack_public_path__ + "img/video.1b932b63.png";